const BASE_URL = (import.meta.env.VITE_EXPLORER_API_BASE_URL ?? "").replace(/\/+$/, "");

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly statusText: string,
    public readonly url: string,
    public readonly problem?: unknown,
  ) {
    super(`${status} ${statusText} for ${url}`);
    this.name = "ApiError";
  }
}

export async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  if (!path.startsWith("/")) {
    throw new Error(`fetchJson path must start with "/": ${path}`);
  }
  const url = `${BASE_URL}${path}`;
  const response = await fetch(url, {
    ...init,
    headers: {
      Accept: "application/json",
      ...init?.headers,
    },
  });
  if (!response.ok) {
    let problem: unknown;
    try {
      problem = (await response.json()) as unknown;
    } catch {
      problem = undefined;
    }
    throw new ApiError(response.status, response.statusText, url, problem);
  }
  return (await response.json()) as T;
}
